export const data = {
  pageTitle: {
    pt: "Vamos Falar",
    eng: "Let's Talk",
  },
  phone: "926909235",
  address: {
    pt1: "Av. Dr. Artur Soares nº23",
    pt2: "S.Vicente, Braga",
  },
  email: "joaoguedes.cjp@gmail.com",
  messageTitle: {
    pt: "Contacte-me",
    eng: "Send me a message",
  },
  form: {
    name: {
      pt: "nome",
      eng: "name",
    },
    subject: {
      pt: "assunto",
      eng: "subject",
    },
    email: "email",
    message: {
      pt: "mensagem",
      eng: "message",
    },
  },
  sendbtn:{
    pt:"Enviar",
    eng:"Send"
  }
};
